import { layoutCategoryFieldModalSliceDispatch } from "../../Constants/ReduxConstants";

//Every reducer needs initial state.
const initialState = {
    open: false
}

export default function layoutCategoryFieldModalSlice(state = initialState, action) {
    switch (action.type) {
        case layoutCategoryFieldModalSliceDispatch.setOpen: {
            return {
                ...state,
                open: action.payload
            }
        }
        case layoutCategoryFieldModalSliceDispatch.setLayoutToAdd: {
            return {
                ...state,
                layoutToAdd: action.payload
            }
        }
        default:
            return state
    }
}
